import { render } from "./HeadingLabel.vue?vue&type=template&id=cb27e150&scoped=true"
import script from "./HeadingLabel.vue?vue&type=script&lang=js"
export * from "./HeadingLabel.vue?vue&type=script&lang=js"

import "./HeadingLabel.vue?vue&type=style&index=0&id=cb27e150&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb27e150"]])

export default __exports__